import { render } from "./KoruBreadcrumb.vue?vue&type=template&id=49ca4245&ts=true"
import script from "./KoruBreadcrumb.vue?vue&type=script&lang=ts"
export * from "./KoruBreadcrumb.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__